import React from 'react';
import PropTypes from 'prop-types';

import styles from './testOverview.scss';
import { t } from '../../services/i18nService';
import sessionReader from '../../store/readHelpers/SessionReader';
import navigationService from '../../services/NavigationService';

const ExitTestButton = React.memo(({ disabled, label, showButtonForNonLockdown }) => {
    const userHasLockdown = sessionReader.userHasLockDown();
    if (!showButtonForNonLockdown && !userHasLockdown) {
        return null;
    }

    return (
        <button className={`${styles.button} btn`} disabled={disabled} onClick={navigationService.exitTest}>
            {t(label || 'general.exit')}
        </button>
    );
});

ExitTestButton.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    showButtonForNonLockdown: PropTypes.bool,
};


export default ExitTestButton;
